export const CONTENT_LIBRARY_ITEM_TYPE = {
    Folder: 0,
    Document: 1,
    Image: 2
};
